<template>
  <TitleParagraphCard
    v-if="value.intro"
    class="pa-8 fill-height"
    color="surface-light"
    :fade="isMoreHidden"
    :value="value.intro"
    @click="toggleMore()"
  >
    <v-row>
      <v-col ccls="12">
        <TitleParagraphBlock
          em-class-title="text-light-blue-darken-2 font-weight-medium"
          :value="value.intro"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        v-for="misc in value.misc_items"
        :key="misc.id"
        :xl="value.misc_items.length > 1 ? 6 : 12"
        class="pb-8"
        cols="12"
      >
        <h3 v-if="misc.title" class="text-h5 font-weight-medium mb-4">
          {{ misc.title }}
        </h3>

        <ContentBlock
          :value="misc"
          class="text-body-1 text-left"
          em-class="text-primary font-weight-black"
      /></v-col>
    </v-row>

    <template v-if="value.badge_image" #header>
      <v-card-item>
        <v-img
          :src="badgeImgSrc(value.badge_image)"
          alt="Badge for this course or certification"
          width="60"
        />
      </v-card-item>
    </template>

    <template v-if="value.misc_items && value.misc_items.length" #footer>
      <v-card-item>
        <v-btn
          class="text-none ma-1"
          exact
          rounded="pill"
          size="large"
          @click.stop="toggleMore()"
        >
          {{ isMoreHidden ? 'Read More' : 'Read Less' }}</v-btn
        >

        <v-btn
          v-if="!value.hide_find_class"
          class="text-none ma-1"
          color="secondary"
          exact
          rounded="pill"
          size="large"
          @click.stop="scrollToSection({ key: 'register' })"
        >
          Find a Class</v-btn
        >
      </v-card-item>
    </template>
  </TitleParagraphCard>
</template>

<script setup>
import { useToggle } from '@vueuse/core'
import { createImgSrc } from '#root/lib/img'

defineProps({
  scrollToSection: {
    default: undefined,
    type: Function
  },
  value: {
    required: true,
    type: Object
  }
})

const [isMoreHidden, toggleMore] = useToggle(true)
const badgeImgSrc = createImgSrc()
</script>
